export default "__VITE_ASSET__fp5hH4Pk__"